module.exports = __webpack_public_path__ + "img/drug-20.a141e846.png";